//State object responsible for holding the state of each component and their props

export const state = {
    callTopics: {
        query: 'SELECT DISTINCT topic FROM opus',
    },
    callUserTopics:{
        query: 'SELECT DISTINCT topic FROM opus WHERE "isActive"=true'
    },
    callDescriptions: {
        query: 'SELECT DISTINCT topic, description, lastupdated FROM opus',
    },
    isLoading: false,
    topics: [],
    topicsList: [],
    pickedTopics: [],
    TopicHeaders: [],
    headerList: [],
    pickedHeaders: [],
    pickedStates: [],
    descriptionsList: [],
    data: [],
    rotatedData: [],
    isOpen: true,
    csvData: [],
    lastUpdated: {},
}

export const EditorState = {

    latestKey: 5,
    table: {
        data: {},
        headers: {
            1: "",
            2: "",
            3: "",
            4: "",
            5: ""
        }
    },
    topic: "",
    alert: {
        send: false,
        isSubmit: false,
        message: "",
    }
}

//State list used to create the states columns
export const StateList = [
    {
        value: 'ak',
        label: 'AK'
    },
    {
        value: 'al',
        label: 'AL'
    },
    {
        value: 'ar',
        label: 'AR'
    },
    {
        value: 'az',
        label: 'AZ'
    },
    {
        value: 'ca',
        label: 'CA'
    },
    {
        value: 'co',
        label: 'CO'
    },
    {
        value: 'ct',
        label: 'CT'
    },
    {
        value: 'dc',
        label: 'DC'
    },
    {
        value: 'de',
        label: 'DE'
    },
    {
        value: 'fl',
        label: 'FL'
    },
    {
        value: 'ga',
        label: 'GA'
    },
    {
        value: 'hi',
        label: 'HI'
    },
    {
        value: 'ia',
        label: 'IA'
    },
    {
        value: 'id',
        label: 'ID'
    },
    {
        value: 'il',
        label: 'IL'
    },
    {
        value: 'in',
        label: 'IN'
    },
    {
        value: 'ks',
        label: 'KS'
    },
    {
        value: 'ky',
        label: 'KY'
    },
    {
        value: 'la',
        label: 'LA'
    },
    {
        value: 'ma',
        label: 'MA'
    },
    {
        value: 'md',
        label: 'MD'
    },
    {
        value: 'me',
        label: 'ME'
    },
    {
        value: 'mi',
        label: 'MI'
    },
    {
        value: 'mn',
        label: 'MN'
    },
    {
        value: 'mo',
        label: 'MO'
    },
    {
        value: 'ms',
        label: 'MS'
    },
    {
        value: 'mt',
        label: 'MT'
    },
    {
        value: 'nc',
        label: 'NC'
    },
    {
        value: 'nd',
        label: 'ND'
    },
    {
        value: 'ne',
        label: 'NE'
    },
    {
        value: 'nh',
        label: 'NH'
    },
    {
        value: 'nj',
        label: 'NJ'
    },
    {
        value: 'nm',
        label: 'NM'
    },
    {
        value: 'nv',
        label: 'NV'
    },
    {
        value: 'ny',
        label: 'NY'
    },
    {
        value: 'oh',
        label: 'OH'
    },
    {
        value: 'ok',
        label: 'OK'
    },
    {
        value: 'or',
        label: 'OR'
    },
    {
        value: 'pa',
        label: 'PA'
    },
    {
        value: 'ri',
        label: 'RI'
    },
    {
        value: 'sc',
        label: 'SC'
    },
    {
        value: 'sd',
        label: 'SD'
    },
    {
        value: 'tn',
        label: 'TN'
    },
    {
        value: 'tx',
        label: 'TX'
    },
    {
        value: 'ut',
        label: 'UT'
    },
    {
        value: 'va',
        label: 'VA'
    },
    {
        value: 'vt',
        label: 'VT'
    },
    {
        value: 'wa',
        label: 'WA'
    },
    {
        value: 'wi',
        label: 'WI'
    },
    {
        value: 'wv',
        label: 'WV'
    },
    {
        value: 'wy',
        label: 'WY'
    }
]

